import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/mangaData";

export default function SerialList() {
  const serialArticles = articles.filter(
    (a) => a.categoryId === "serializing" || a.categoryId === "latest",
  );
  const updateItems = [...serialArticles]
    .slice(0, 5)
    .map((a) => ({ article: a, cat: categories.find((c) => c.id === a.categoryId) }));

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6" aria-labelledby="serial-heading">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <h2 id="serial-heading" className="font-heading text-2xl text-foreground-950 md:text-3xl">
            连载更新 · 进度表
          </h2>
          <p className="mt-2 text-sm text-foreground-600">一目了然掌握每部作品的连载进度与更新安排。</p>
        </div>
        <Link
          to="/category/serializing"
          className="inline-flex whitespace-nowrap items-center gap-1 text-sm text-primary-600 transition-colors hover:text-primary-700"
        >
          全部连载 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-6 space-y-3">
        {updateItems.map(({ article, cat }, index) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200 hover:bg-background-100 md:gap-5 md:p-4"
          >
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-100 font-heading text-sm text-foreground-700">
              {String(index + 1).padStart(2, "0")}
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                {cat && <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">{cat.name}</span>}
                {article.updateInfo && (
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                    <i className="ri-time-line" />
                    {article.updateInfo}
                  </span>
                )}
              </div>
              <h3 className="mt-1 truncate text-sm font-medium text-foreground-950 md:text-base">{article.title}</h3>
            </div>
            <span className="hidden shrink-0 text-sm text-foreground-500 sm:block">{article.date}</span>
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-white">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}